export default function intersperse(array, separator = ', ') {
  const valuesWithSeparator = array.reduce(
    (acc, cur) => acc.concat(cur, separator),
    [],
  );
  valuesWithSeparator.pop();
  return valuesWithSeparator;
}
